import { render, staticRenderFns } from "./popular-FAQs.vue?vue&type=template&id=30e8760c&"
import script from "./popular-FAQs.js?vue&type=script&lang=js&"
export * from "./popular-FAQs.js?vue&type=script&lang=js&"
import style0 from "./popular-FAQs.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports